import React from 'react'

export default function NotesItem(props) {
      
    return (
        <>
        <div className="card my-3 mb-5 h-100 border border-success" style={{borderRadius: "15px"}}>
          <div className="card-body">
            <h5 className="mb-3">{props.notesreason}</h5>
            <p className='h-50'>{props.notesdescription}</p>
            <div className="small">| By <strong className="text-primary">{props.notesAgent}</strong> on {props.notesdate}</div>
          </div>
        </div>
        </>
    )
  
}